import { Component, input } from '@angular/core';
import { WinCardEightVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe, TransformUrlToBgPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant8',
  imports: [RewardPipe, SafePipe, TransformUrlToBgPipe],
  styleUrl: './variant8.component.scss',
  templateUrl: './variant8.component.html',
})
export class Variant8Component {
  amount = input<number>(0);
  config = input.required<WinCardEightVariantConfig>();
}
